import axios from 'axios';

// Configure axios to send cookies with requests
axios.defaults.withCredentials = true;

/**
 * Generic Method to make an axios GET method
 * @param {*} path
 */
export const API_FETCH = async (path: string) => {
  try {
    const response = await axios.get(path);
    return response.data;
  } catch (error: any) {
    // Pass raw axios error - middleware will transform it
    throw error;
  }
};

/**
 * Generic Method to make an axios POST method
 * @param {*} path
 * @param {*} payload
 * @param {*} headers
 */
export const API_POST = async (path: string, payload: any, headers?: any) => {
  try {
    const response = await axios.post(path, payload, headers ? { headers } : undefined);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

/**
 * Generic Method to make an axios PUT method
 * @param {*} path
 * @param {*} payload
 */
export const API_UPDATE = async (path: string, payload: any) => {
  try {
    const response = await axios.put(path, payload);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

/**
 * Generic Method to make an axios DELETE method
 * @param {*} path
 */
export const API_DELETE = async (path: string) => {
  try {
    const response = await axios.delete(path);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

/**
 * Generic Method to fetch a file via axios POST with a blob response.
 * Returns the Blob alongside the server-supplied filename (extracted from the
 * Content-Disposition header), falling back to fallbackFileName if absent.
 * Callers should validate the body (size, type) before passing the blob to
 * saveBlobAsFile (in utils/appUtils).
 * @param {*} path
 * @param {*} payload
 * @param {*} fallbackFileName - Used when the server does not return a filename
 * @param {*} headers
 */
export const API_DOWNLOAD = async (
  path: string,
  payload: any,
  fallbackFileName: string,
  headers?: any,
) => {
  try {
    const response = await axios.post(path, payload, {
      ...(headers ? { headers } : {}),
      responseType: 'blob',
    });
    const contentDisposition = response.headers['content-disposition'];
    const match = contentDisposition?.match(/filename[^;=\n]*=(['"]?)([^'"\n;]+)\1/);
    return {
      blob: response.data as Blob,
      fileName: match?.[2] ?? fallbackFileName,
    };
  } catch (error: any) {
    throw error;
  }
};
